import { render, staticRenderFns } from "./exportKeywords.vue?vue&type=template&id=0c6af12f&scoped=true"
import script from "./exportKeywords.vue?vue&type=script&lang=ts"
export * from "./exportKeywords.vue?vue&type=script&lang=ts"
import style0 from "./exportKeywords.vue?vue&type=style&index=0&id=0c6af12f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6af12f",
  null
  
)

export default component.exports